import { Linkedin, Mail, Phone, MapPin, ArrowRight, Download } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-slate-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="space-y-4">
            <h2 className="text-2xl font-bold font-heading text-white">Uma Ispat Private Limited</h2>
            <p className="text-sm leading-relaxed text-white/90">
              Setting the benchmark in iron and steel trading since 1996.
              Built on trust, powered by precision, and dedicated to excellence.
            </p>
            <div className="flex space-x-4 pt-2">
              <a
                href="https://www.linkedin.com/company/uma-ispat/"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-slate-800 rounded-full text-slate-400 hover:text-white hover:bg-accent transition-all duration-300"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="#home" className="text-sm hover:text-accent transition-colors flex items-center gap-2 group">
                  <ArrowRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  <span className="transform group-hover:translate-x-1 transition-transform">Home</span>
                </a>
              </li>
              <li>
                <a href="#about" className="text-sm hover:text-accent transition-colors flex items-center gap-2 group">
                  <ArrowRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  <span className="transform group-hover:translate-x-1 transition-transform">About Us</span>
                </a>
              </li>
              <li>
                <a href="#products" className="text-sm hover:text-accent transition-colors flex items-center gap-2 group">
                  <ArrowRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                  <span className="transform group-hover:translate-x-1 transition-transform">Products</span>
                </a>
              </li>
              <li>
                <a href="/downloads/brochure.pdf" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-accent transition-colors flex items-center gap-2 group text-accent font-medium">
                  <Download size={14} />
                  <span>Download Brochure</span>
                </a>
              </li>
              <li>
                <a href="/downloads/company-profile.pdf" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-accent transition-colors flex items-center gap-2 group text-accent font-medium">
                  <Download size={14} />
                  <span>Company Profile</span>
                </a>
              </li>
            </ul>
          </div>

          {/* Services/Products */}
          <div>
            <h3 className="text-white font-semibold mb-6">Our Products</h3>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>HR Coils</li>
              <li>CR Coils</li>
              <li>GP & Chequered Coils</li>
              <li>HSM Plates</li>
              <li>PM Plates</li>
              <li>HR Sheets</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-6">Contact Us</h3>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-accent shrink-0 mt-0.5" />
                <span>Plot No. 5, Co-operative Colony,<br />Bokaro Steel City,<br />Jharkhand – 827001</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-accent shrink-0" />
                <span>+91 90519 99959</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-accent shrink-0" />
                <span>info@umaispat.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-500">
          <p>&copy; {currentYear} Uma Ispat Private Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;